import { Divider, Typography } from 'antd'
import React from 'react'
import BinOutWardWash from '../../../components/Wash/BinOutward/BinOutWardWash'
import BinOutwardWash from '../../../components/Wash/BinOutward/BinOutWardWash'

const BinOutwardWashPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Bin Outward
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <BinOutwardWash userData={userData} />
    </>
  )
}

export default BinOutwardWashPage